import { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const TVL_PERIODS = ['1W', '1M', '3M', '6M', 'All-time']

const ITEM_BASE =
  'staking-tvl-filter-item flex w-full cursor-pointer items-center justify-between gap-2 rounded-control p-2 text-left text-sm/sm text-ink transition-colors outline-none bg-transparent hover:bg-ink/5 data-highlighted:bg-ink/5 data-disabled:opacity-50 data-disabled:bg-transparent'

const ITEM_SELECTED = `${ITEM_BASE} font-medium`

function CheckIcon({ visible }) {
  return (
    <span
      data-icon="true"
      className={`flex size-3 shrink-0 items-center justify-center text-ink ${
        visible ? 'opacity-85' : 'opacity-0'
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        fill="currentColor"
        className="size-full"
      >
        <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" />
      </svg>
    </span>
  )
}

function MenuItem({ label, selected, onSelect }) {
  return (
    <div
      role="menuitem"
      tabIndex={-1}
      data-orientation="vertical"
      className={selected ? ITEM_SELECTED : ITEM_BASE}
      onClick={() => onSelect(label)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onSelect(label)
        }
      }}
    >
      <div className="flex items-center gap-2">
        <span>{label}</span>
      </div>
      <div className="flex items-center gap-2">
        <CheckIcon visible={selected} />
      </div>
    </div>
  )
}

export default function TvlFilterMenu({ period, onPeriod, anchorRef }) {
  const [pos, setPos] = useState(null)

  useLayoutEffect(() => {
    const el = anchorRef?.current
    if (!el) return undefined
    const update = () => {
      const rect = el.getBoundingClientRect()
      setPos({
        top: rect.bottom + 6,
        right: window.innerWidth - rect.right,
      })
    }
    update()
    window.addEventListener('resize', update)
    window.addEventListener('scroll', update, true)
    return () => {
      window.removeEventListener('resize', update)
      window.removeEventListener('scroll', update, true)
    }
  }, [anchorRef])

  if (!pos) return null

  return createPortal(
    <div
      data-testid="staking-chart-filter-menu"
      data-side="bottom"
      data-align="end"
      data-state="open"
      data-dropdown-menu-content="true"
      role="menu"
      aria-orientation="vertical"
      tabIndex={-1}
      dir="ltr"
      className="staking-tvl-filter-menu z-9999 max-h-96 overflow-y-scroll rounded-card border-0 bg-elevated p-1 shadow-elevate-popover anim-picker-in light:bg-overlay"
      style={{
        outline: 'none',
        position: 'fixed',
        top: pos.top,
        right: pos.right,
      }}
    >
      <div className="flex">
        <div className="staking-tvl-filter-col flex min-w-[124px] flex-col">
          <span className="staking-tvl-filter-heading px-2 py-1 font-mono label-meta text-muted">
            Period
          </span>
          {TVL_PERIODS.map((option) => (
            <MenuItem
              key={option}
              label={option}
              selected={option === period}
              onSelect={onPeriod}
            />
          ))}
        </div>
      </div>
    </div>,
    document.body
  )
}
